export default __webpack_public_path__ + "static/media/Doc_Default_Icon.0f62a37b.svg";